import React from 'react';
import Connected, { ConnectedProps, ConnectedState } from './connected';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import { transaction } from 'mobx';
import { pointInAdsorpRange } from '../../../../../../../slide/infrastructure/module/independent/graphic/rotate';
import { POINT_ADSORP_RANGE } from '@src/slide/infrastructure/module/independent/graphic/rotate';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import Cursor from '../../../../../../../css/ppt-editor-cursor-global.less';
import connectorStyles from './element-types/connector-element/index.css';
import SelectBorder from './select-border-pc';
import get from 'lodash/get';
import set from 'lodash/set';


interface IPoint {
    x: number;
    y: number;
}

interface AdsorbConnectProps extends ConnectedProps {}

interface AdsorbConnectState extends ConnectedState {
    isOnAdsorb: boolean;
}

const textSubType = 1;
class AdsorbConnect extends Connected<AdsorbConnectProps, AdsorbConnectState> {
    private adsorbPoints: IPoint[];

    public constructor(props) {
        super(props);
        this.state = {
            isOnElement: false,
            isOnAdsorb: false,
        };
        this.pointRefs = [];
    }

    /*
     * Render
     */
    public render() {
        // 连接线只有顶端吸附点逻辑，所以无需渲染其他功能
        if (this.props.component?.type === UIModelType.CONNECTOR) {
            return (
                <React.Fragment>
                    {/* 矩形/连接线顶端吸附点 */}
                    {this.renderAdsorbPoints()}
                </React.Fragment>
            );
        }
        // 其他图形
        return (
            <React.Fragment>
                {/* 图形hover区域 */}
                {
                    <div
                        onMouseMove={this.handleMouseMoveElement}
                        onMouseOut={this.handleMouseOutElement}
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            boxSizing: 'content-box',
                            padding: '15px',
                            top: '-15px',
                            left: '-15px',
                            zIndex: 1000,
                            pointerEvents: 'auto',
                        }}
                    >
                        {/* 矩形/连接线顶端吸附点（为了保证边框高亮，所以放在hover区域内） */}
                        {this.renderAdsorbPoints()}
                    </div>
                }
                {/* 文本框连接线头尾hover时边框高亮 */}
                {this.state.isOnElement && this.renderHighLightRect()}
                {/* 常规吸附点 */}
                {this.state.isOnElement && this.renderConnectedPoints()}
            </React.Fragment>
        );
    }

    public componentWillUnmount(): void {
        const connectorInfo = this.props.editingStateManager?.connectingInfo;
        if (connectorInfo) {
            set(connectorInfo.model, 'adsorbInfo', null);
        }
    }

    protected renderConnectedPoint = (point, index) => {
        const scale = this.getScaleNum();
        return (
            <div
                key={index}
                className={`${connectorStyles.connectedPoint} ${Cursor.move}`}
                style={{
                    left: point.x - 5,
                    top: point.y - 5,
                    position: 'absolute',
                    pointerEvents: 'none',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.32)',
                    transform: `scale(${1 / scale})`,
                    zIndex: 1000,
                }}
                ref={(el) => {
                    this.pointRefs[index] = el;
                }}
            >
            </div>
        );
    };

    private renderHighLightRect = () => {
        const rect = {
            left: this.props.styleModel.left,
            top: this.props.styleModel.top,
            width: this.props.styleModel.width,
            height: this.props.styleModel.height,
        };
        // @ts-ignore
        if (this.props.styleModel.subType === textSubType) {
            return (<SelectBorder
                scale={this.props.scale}
                frame={rect}
                style={{ top: 0, left: 0 }}
                borderDraggable={false}
                isSelected={true}
                shouldRoundSize={this.props.component.type === UIModelType.SHAPE
                    || this.props.component.type === UIModelType.IMAGE}
            />
            );
        }
        return null;
    };

    private renderAdsorbPoints = () => {
        this.adsorbPoints = this.getCornerPointsOnSlide(this.props.component);
        return (
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                }}
            >
                { this.adsorbPoints.map(this.renderAdrobPoint) }
            </div>
        );
    };

    private renderAdrobPoint = (point, index) => {
        const scale = this.getScaleNum();
        return (
            <div
                key={index}
                onMouseMove={this.handleMouseMoveAdsorbDiv}
                onMouseOut={this.handleMouseOutAdsorbDiv}
                style={{
                    left: point.x - (POINT_ADSORP_RANGE * scale),
                    top: point.y - (POINT_ADSORP_RANGE * scale),
                    width: POINT_ADSORP_RANGE * 2 * scale,
                    height: POINT_ADSORP_RANGE * 2 * scale,
                    position: 'absolute',
                    pointerEvents: 'auto',
                    zIndex: 1001,
                }}
            >
            </div>
        );
    };

    /*
     * Handle the mouse move. Calculate new target position
     */
    private handleMouseMoveAdsorbDiv = (e): void => {
        if (this.state.isOnAdsorb === false) {
            this.setState({
                isOnAdsorb: true,
            });
        }
        const p = {
            x: e.clientX,
            y: e.clientY,
        };
        const scale = this.getScaleNum();
        const boundingRect = e.currentTarget.getBoundingClientRect();
        const centerPoint = {
            x: boundingRect.left + (boundingRect.width / 2),
            y: boundingRect.top + (boundingRect.height / 2),
        };
        const isInadsorbRange = pointInAdsorpRange(p, centerPoint, scale);
        let adsorbPoint;
        if (isInadsorbRange) {
            adsorbPoint = this.getAdsorbPoint(centerPoint);
        } else {
            adsorbPoint = null;
        }
        const connectorInfo = this.props.editingStateManager.connectingInfo;
        transaction(() => {
            if (!connectorInfo) return;
            if (adsorbPoint) {
                set(connectorInfo.model, 'adsorbInfo.adsorbPoint', adsorbPoint);
                if (connectorInfo.endIndex === 0 || connectorInfo.endIndex === 1) {
                    set(connectorInfo.model, 'adsorbInfo.endIndex', connectorInfo.endIndex);
                }
            } else {
                set(connectorInfo.model, 'adsorbInfo', null);
            }
        });
    };

    private handleMouseOutAdsorbDiv = (): void => {
        if (this.state.isOnAdsorb === true) {
            this.setState({
                isOnAdsorb: false,
            });
        }
        const connectorInfo = this.props.editingStateManager.connectingInfo;
        transaction(() => {
            connectorInfo && set(connectorInfo.model, 'adsorbInfo', null);
        });
    };

    private getAdsorbPoint = (centerPoint: IPoint): IPoint => {
        if (this.props.editingStateManager.insertState.type !== null) {
            return centerPoint;
        }
        return this.pageToSlide(centerPoint);
    };

    /**
     * 将相对于slide的点坐标转换为相对于可滚动页面
     * @param point
     */
    private pageToSlide = (currentPoint: IPoint): IPoint => {
        const scale = this.getScaleNum();
        const slide = document.getElementById('slide');
        if (!slide) return currentPoint;
        const rect = slide.getBoundingClientRect();
        const point = {
            x: (currentPoint.x - rect.left) / scale,
            y: (currentPoint.y - rect.top) / scale,
        };
        return point;
    };

    /**
     * 获取吸附点
     * @param model
     */
    private getCornerPointsOnSlide = (component): IPoint[] => {
        let points: IPoint[] = [];
        if (get(component?.props?.style, 'bgShape') === ShapeType.rect) {
            points = [
                {
                    x: 0,
                    y: 0,
                },
                {
                    x: 0,
                    y: component.props.style.height,
                },
                {
                    x: component.props.style.width,
                    y: 0,
                },
                {
                    x: component.props.style.width,
                    y: component.props.style.height,
                },
            ];
        }
        if (component?.type === UIModelType.CONNECTOR) {
            points = [
                {
                    x: 0,
                    y: 0,
                },
                {
                    x: component.props.style.width,
                    y: component.props.style.height,
                },
            ];
        }
        return points;
    };
}

export default AdsorbConnect;
